/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type EvtClaimPartnerFee = {
  pool: Address;
  tokenAAmount: bigint;
  tokenBAmount: bigint;
};

export type EvtClaimPartnerFeeArgs = {
  pool: Address;
  tokenAAmount: number | bigint;
  tokenBAmount: number | bigint;
};

export function getEvtClaimPartnerFeeEncoder(): FixedSizeEncoder<EvtClaimPartnerFeeArgs> {
  return getStructEncoder([
    ["pool", getAddressEncoder()],
    ["tokenAAmount", getU64Encoder()],
    ["tokenBAmount", getU64Encoder()],
  ]);
}

export function getEvtClaimPartnerFeeDecoder(): FixedSizeDecoder<EvtClaimPartnerFee> {
  return getStructDecoder([
    ["pool", getAddressDecoder()],
    ["tokenAAmount", getU64Decoder()],
    ["tokenBAmount", getU64Decoder()],
  ]);
}

export function getEvtClaimPartnerFeeCodec(): FixedSizeCodec<
  EvtClaimPartnerFeeArgs,
  EvtClaimPartnerFee
> {
  return combineCodec(
    getEvtClaimPartnerFeeEncoder(),
    getEvtClaimPartnerFeeDecoder(),
  );
}
